<!-- This crew card is for the scheduling pages, it has indelible employees/equipment and
can be dragged onto a day for scheduling.
Basically, this card is used to view crews.
WARNING: If you make a change to this card, check the other crew card to see if it needs the change as well.
-->
<p-card class="crew-card" [ngClass]="{'crew-invalid': crewErrors.length > 0 }">
  <p-header>
    {{crewTitle}}

    @if (crewErrors.length > 0) {
      <div style="float: right;">
        <i class="pi pi-exclamation-triangle" (click)="errorPanel.toggle($event)"></i>
        <p-popover #errorPanel>
          @for (error of crewErrors; track error) {
            <div>
              {{error}}
            </div>
          }
        </p-popover>
      </div>
    }
  </p-header>

  {{employeeList}}

  <div class="toggle-tasks">
    @if (isCollapsed) {
      <div>
        <span (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span">
          +
        </span>
      </div>
    }
    @if (!isCollapsed) {
      <div>
        <span (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span">
          -
        </span>
      </div>
    }
    <div [ngbCollapse]="isCollapsed" class="crew-work-orders">
      @if (crew.crewEquipment) {
        <div>
          Equipment
          @for (crewEquip of crew.crewEquipment; track crewEquip) {
            <div class="inner-card">
              <app-equipment-card [equipment]="crewEquip.equipment"></app-equipment-card>
            </div>
          }
        </div>
      }
      @if (crew.crewEmployees) {
        <div>
          Employees
          @for (crewEmployee of crew.crewEmployees; track crewEmployee) {
            <div class="inner-card">
              <app-employee-card [employee]="crewEmployee.employee"></app-employee-card>
            </div>
          }
        </div>
      }
    </div>
  </div>
</p-card>
